export default "__VITE_ASSET__C5_VPHPF__"